import { useQuery } from '@tanstack/react-query';

import { getReward } from '~/services/AgentHub/AgentService';

import { rewardQueryKeys } from './useListRewards';

interface UseGetRewardOptions {
  enabled?: boolean;
}

export function useGetReward(id?: string, options: UseGetRewardOptions = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: rewardQueryKeys.detail(id ?? ''),
    queryFn: async () => {
      return await getReward(id!);
    },
    enabled: enabled && Boolean(id),
    staleTime: 5 * 60 * 1000,
  });
}
